'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hatsuon;

var _utils = require('./utils');

/**
 * Returns pitch accent information for the provided word and pitch number
 *
 * @module
 * @param {string} [reading=''] Japanese word represented in kana
 * @param {number} [pitchNum=-1] pitch number
 * @returns {object} pitch data
 */
function hatsuon() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$reading = _ref.reading,
      reading = _ref$reading === undefined ? '' : _ref$reading,
      _ref$pitchNum = _ref.pitchNum,
      pitchNum = _ref$pitchNum === undefined ? -1 : _ref$pitchNum,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? 'JA' : _ref$locale;

  var morae = (0, _utils.getMorae)(reading);
  return {
    reading: reading,
    morae: morae,
    pitchNum: pitchNum,
    pattern: (0, _utils.makePitchPattern)(morae.length, pitchNum),
    patternName: (0, _utils.getPitchPatternName)(morae.length, pitchNum, locale)
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/hatsuon/dist/index.js
// module id = 539
// module chunks = 0